import { useChecklistStore } from '../../../../stores/checklistStore';
import CategoryItem from './CategoryItem';

interface Props {
    centerId: string;
    variant?: 'default' | 'onboarding';
}

const CategoryList: React.FC<Props> = ({ centerId, variant = 'default' }) => {
    const { categories } = useChecklistStore();

    return (
        <div className="space-y-4" >
            {categories.map((category, index) => (
                <CategoryItem key={category.id} category={category} centerId={centerId} variant={variant} index={index} />
            ))}
        </div>
    );
};

export default CategoryList;
